// Add and use utility functions here to reuse for all components.

export function useUtils() {
  const openLinkInTab = (link, target = "_blank") => {
    window.open(link, target);
  };

  return { openLinkInTab };
}
